export const AnalyticsOpenFromValues = {
  PROFILE: "PROFILE",
  FIND_SHIFT_DETAILS: "FIND_SHIFT_DETAILS",
  BOOKING_DETAILS: "BOOKING_DETAILS",
} as const;
